import { KUuid } from '../../core/utils'

export default {
  name: 'KRadioGroup',
  provide() {
    return {
      radioGroup: this,
    }
  },
  props: {
    value: {
      validator: () => true,
      default: null,
    },
    checkedTheme: {
      type: String,
      default: 'outlined',
    },
    uncheckedTheme: {
      type: String,
      default: 'outlined',
    },
    checkedType: {
      type: String,
      default: 'primary',
    },
    uncheckedType: {
      type: String,
      default: 'light',
    },
    size: {
      type: String,
      default: null,
    },
    // 胶囊模式
    capsule: {
      type: Boolean,
      default: false,
    },
    // 胶囊模式样式 rounded 或 square
    capsuleType: {
      type: String,
      default: 'rounded',
    },
    // 选填场景 可取消
    cancelable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerValue: '',
    }
  },
  computed: {
    name() {
      return 'rg-' + KUuid()
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.innerValue = value
      },
    },
  },
  created() {
  },
  mounted() {
  },
  render() {
    return <div
      class={{
        'km-radio-group': true,
        'km-control-group': !this.capsule,
        'km-radio-group--capsule': this.capsule,
      }}
    >{this.$slots.default}</div>
  },
  methods: {
    handleValueChange(value) {
      this.$emit('input', value)
    },
  },
}
